import { Activity, ClipboardList, Factory, Landmark, Package, Receipt, Settings, FileText, BookOpen } from "lucide-react";
import { Bot, Building2, FlaskConical, Users } from "lucide-react";

export const primaryNavigation = [
  { label: "Overview", path: "/", icon: Activity, testId: "nav-overview" },
  { label: "Planning", path: "/planning", icon: Factory, role: "planning_analyst", testId: "nav-planning" },
  { label: "Daily Report", path: "/production-report", icon: ClipboardList, role: ["daily_report", "planning_analyst"], testId: "nav-production-report" },
  { label: "Finance", path: "/financial-analyst", icon: Landmark, role: "financial_analyst", testId: "nav-financial-analyst" },
  { label: "GST Report", path: "/gst-report", icon: FileText, role: ["gst_report", "financial_analyst"], testId: "nav-gst-report" },
  { label: "Supply Chain", path: "/supply-chain", icon: Package, role: "supply_chain_analyst", testId: "nav-supply-chain" },
  { label: "Purchasing", path: "/purchasing", icon: Receipt, role: "purchasing_analyst", testId: "nav-purchasing" },
  { label: "Settings", path: "/settings", icon: Settings, adminOnly: true, testId: "nav-settings" },
  { label: "User Manual", path: "/user-manual", icon: BookOpen, testId: "nav-user-manual" },
  { label: "Users", path: "/users", icon: Users, adminOnly: true, testId: "nav-users" },
  { label: "AI Config", path: "/ai-config", icon: Bot, role: "ai_config", adminOnly: true, testId: "nav-ai-config" },
  { label: "Organizations", path: "/organizations", icon: Building2, role: "organizations", adminOnly: true, testId: "nav-organizations" },
  { label: "Audit Log", path: "/audit-log", icon: FlaskConical, role: "audit_log", adminOnly: true, testId: "nav-audit-log" },
];

// Searchable destinations include the planning workspace tabs as well as the
// top-level navigation. These are navigation shortcuts, not SAP data searches.
export const moduleSearchItems = [
  ...primaryNavigation.map((item) => ({ ...item, keywords: [item.label] })),
  { label: "Materials", description: "Production Planning", path: "/planning?tab=materials", role: "planning_analyst", keywords: ["material master", "products", "inventory material"] },
  { label: "Sales Orders", description: "Production Planning", path: "/planning?tab=sales-orders", role: "planning_analyst", keywords: ["customer orders", "sales order"] },
  { label: "Planning Report", description: "Production Planning", path: "/planning?tab=planning-report", role: "planning_analyst", keywords: ["production planning report", "order coverage"] },
  { label: "AI Planning Agent", description: "Production Planning", path: "/planning?tab=ai-agent", role: "planning_analyst", keywords: ["planning ai", "bom", "availability"] },
  { label: "Scheduling", description: "Production Planning", path: "/planning?tab=scheduling", role: "planning_analyst", keywords: ["production schedule", "gantt", "work center"] },
  { label: "Demand Forecast", description: "Production Planning", path: "/planning?tab=forecasting", role: "planning_analyst", keywords: ["forecasting", "demand planning"] },
  { label: "Production Order Tracker", description: "Production Planning", path: "/planning?tab=po-tracker", role: "planning_analyst", keywords: ["po tracker", "production orders", "order status"] },
];

export const canAccessNavigationItem = (item, { isAdmin, hasRole }) => {
  if (item.adminOnly) {
    if (isAdmin) return true;
    if (item.role) {
      const allowed = Array.isArray(item.role) ? item.role : [item.role];
      return allowed.some((r) => hasRole(r));
    }
    return false;
  }
  if (item.role) {
    const allowed = Array.isArray(item.role) ? item.role : [item.role];
    return allowed.some((r) => hasRole(r));
  }
  return true;
};

